import { asq, toDictionary as toDictionary$1 } from '@sembo-private/asq';
import { Observable, toArray, map } from 'rxjs';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$f =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$j = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$i = fails$j;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$h = fails$j;

var functionBindNative = !fails$h(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$2 = functionBindNative;

var call$c = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$c.bind(call$c) : function () {
  return call$c.apply(call$c, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$b = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$2.bind.bind(call$b, call$b);

var functionUncurryThisRaw = function (fn) {
  return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function () {
    return call$b.apply(fn, arguments);
  };
};

var uncurryThisRaw$1 = functionUncurryThisRaw;

var toString$a = uncurryThisRaw$1({}.toString);
var stringSlice$5 = uncurryThisRaw$1(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$5(toString$a(it), 8, -1);
};

var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;

var functionUncurryThis = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
};

var uncurryThis$h = functionUncurryThis;
var fails$g = fails$j;
var classof$4 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$h(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$g(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$8 = function (it) {
  if (isNullOrUndefined$3(it)) throw $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$7 = requireObjectCoercible$8;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$7(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$h = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$g = isCallable$h;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$7 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it);
};

var global$e = global$f;
var isCallable$f = isCallable$h;

var aFunction = function (argument) {
  return isCallable$f(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$e[namespace]) : global$e[namespace] && global$e[namespace][method];
};

var uncurryThis$g = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$g({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$d = global$f;
var userAgent = engineUserAgent;

var process = global$d.process;
var Deno = global$d.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$f = fails$j;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$f(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$e = isCallable$h;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$e($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$d = isCallable$h;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$d(argument)) return argument;
  throw $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable(func);
};

var call$a = functionCall;
var isCallable$c = isCallable$h;
var isObject$6 = isObject$7;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$c(fn = input.toString) && !isObject$6(val = call$a(fn, input))) return val;
  if (isCallable$c(fn = input.valueOf) && !isObject$6(val = call$a(fn, input))) return val;
  if (pref !== 'string' && isCallable$c(fn = input.toString) && !isObject$6(val = call$a(fn, input))) return val;
  throw $TypeError$6("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$c = global$f;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$5(global$c, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$c[key] = value;
  } return value;
};

var global$b = global$f;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$b[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.5',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$6 = requireObjectCoercible$8;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$6(argument));
};

var uncurryThis$f = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$f({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$e = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$9 = uncurryThis$e(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$9(++id + postfix, 36);
};

var global$a = global$f;
var shared$3 = shared$4.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$2 = global$a.Symbol;
var symbolFor = Symbol$2 && Symbol$2['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$c = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$9(Symbol$2, name)) {
      WellKnownSymbolsStore[name] = Symbol$2[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$9 = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$b = wellKnownSymbol$c;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$b('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$9(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$9 = global$f;
var isObject$4 = isObject$7;

var document$1 = global$9.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$e = fails$j;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$e(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$8 = descriptors;
var call$8 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$8(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$7 = descriptors;
var fails$d = fails$j;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$7 && fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$3 = isObject$7;

var $String$2 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$3(argument)) return argument;
  throw $TypeError$4($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$9 = anObject$a;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$d = functionUncurryThis;
var isCallable$b = isCallable$h;
var store$1 = sharedStore;

var functionToString = uncurryThis$d(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$8 = global$f;
var isCallable$a = isCallable$h;

var WeakMap$1 = global$8.WeakMap;

var weakMapBasicDetection = isCallable$a(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$7 = global$f;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$6 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$7.TypeError;
var WeakMap = global$7.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$c = fails$j;
var isCallable$9 = isCallable$h;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$c(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$9(this) && getInternalState$2(this).source || inspectSource(this);
}, 'toString');

var isCallable$8 = isCallable$h;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$8(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$c = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$c([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$b = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$a;

var concat$2 = uncurryThis$b([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$b = fails$j;
var isCallable$7 = isCallable$h;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$7(detection) ? fails$b(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$6 = global$f;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$6;
  } else if (STATIC) {
    target = global$6[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$6[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var wellKnownSymbol$a = wellKnownSymbol$c;

var TO_STRING_TAG$3 = wellKnownSymbol$a('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$6 = isCallable$h;
var classofRaw = classofRaw$2;
var wellKnownSymbol$9 = wellKnownSymbol$c;

var TO_STRING_TAG$2 = wellKnownSymbol$9('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$6(O.callee) ? 'Arguments' : result;
};

var classof$2 = classof$3;

var $String$1 = String;

var toString$8 = function (argument) {
  if (classof$2(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var anObject$7 = anObject$a;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$a = fails$j;
var global$5 = global$f;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$5.RegExp;

var UNSUPPORTED_Y$1 = fails$a(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$a(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$a(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$6 = anObject$a;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$6(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$4;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$5 = anObject$a;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$5(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$9 = fails$j;
var global$4 = global$f;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$4.RegExp;

var regexpUnsupportedDotAll = fails$9(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$8 = fails$j;
var global$3 = global$f;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$3.RegExp;

var regexpUnsupportedNcg = fails$8(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$7 = functionCall;
var uncurryThis$a = functionUncurryThis;
var toString$7 = toString$8;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create$2 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$a(''.charAt);
var indexOf = uncurryThis$a(''.indexOf);
var replace$2 = uncurryThis$a(''.replace);
var stringSlice$4 = uncurryThis$a(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$7(nativeExec, re1, 'a');
  call$7(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$7(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$7(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$7(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$4(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$7(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$4(match.input, charsAdded);
        match[0] = stringSlice$4(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$7(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$6 = _export;
var exec$1 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$6({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$9 = functionUncurryThis;
var defineBuiltIn$3 = defineBuiltIn$5;
var regexpExec$1 = regexpExec$2;
var fails$7 = fails$j;
var wellKnownSymbol$8 = wellKnownSymbol$c;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol$8('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$8(KEY);

  var DELEGATES_TO_SYMBOL = !fails$7(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$7(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$9(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$9(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$3(String.prototype, KEY, methods[0]);
    defineBuiltIn$3(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$2(RegExpPrototype$2[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call$6 = functionCall;
var anObject$4 = anObject$a;
var isCallable$5 = isCallable$h;
var classof$1 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$2 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$5(exec)) {
    var result = call$6(exec, R, S);
    if (result !== null) anObject$4(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$6(regexpExec, R, S);
  throw $TypeError$2('RegExp#exec called on incompatible receiver');
};

var call$5 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$3 = anObject$a;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var requireObjectCoercible$5 = requireObjectCoercible$8;
var sameValue = sameValue$1;
var toString$6 = toString$8;
var getMethod$1 = getMethod$3;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$5(this);
      var searcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$5(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$6(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$3(this);
      var S = toString$6(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var wellKnownSymbol$7 = wellKnownSymbol$c;
var create$1 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$7('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$6 = fails$j;

var correctPrototypeGetter = !fails$6(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$4 = isCallable$h;
var toObject$2 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$5 = fails$j;
var isCallable$3 = isCallable$h;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$6 = wellKnownSymbol$c;

var ITERATOR$3 = wellKnownSymbol$6('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$5(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$5 = wellKnownSymbol$c;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$1)) {
    defineProperty$2(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$2 = isCallable$h;

var $String = String;
var $TypeError$1 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$2(argument)) return argument;
  throw $TypeError$1("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$8 = functionUncurryThis;
var anObject$2 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$8(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$2(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$5 = _export;
var call$4 = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$h;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var defineBuiltIn$1 = defineBuiltIn$5;
var wellKnownSymbol$4 = wellKnownSymbol$c;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$4('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$2])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$4(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$5({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$2, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$1 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$1 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$f;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol$3 = wellKnownSymbol$c;

var ITERATOR$1 = wellKnownSymbol$3('iterator');
var TO_STRING_TAG = wellKnownSymbol$3('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$1] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$1, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$1] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var isObject = isObject$7;
var classof = classofRaw$2;
var wellKnownSymbol$2 = wellKnownSymbol$c;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$c;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$4 = _export;
var uncurryThis$7 = functionUncurryThis;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$3;
var toString$5 = toString$8;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$8;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis$7(''.startsWith);
var stringSlice$3 = uncurryThis$7(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic$1('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$4({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$5(requireObjectCoercible$4(this));
    notARegExp$1(searchString);
    var index = toLength$1(min$1(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$5(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice$3(that, index, index + search.length) === search;
  }
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$3 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$3.bind(apply$1) : function () {
  return call$3.apply(apply$1, arguments);
});

var uncurryThis$6 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$4 = toString$8;
var requireObjectCoercible$3 = requireObjectCoercible$8;

var charAt$2 = uncurryThis$6(''.charAt);
var charCodeAt = uncurryThis$6(''.charCodeAt);
var stringSlice$2 = uncurryThis$6(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$4(requireObjectCoercible$3($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$5 = functionUncurryThis;
var toObject$1 = toObject$4;

var floor = Math.floor;
var charAt = uncurryThis$5(''.charAt);
var replace$1 = uncurryThis$5(''.replace);
var stringSlice$1 = uncurryThis$5(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call$2 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$4 = fails$j;
var anObject$1 = anObject$a;
var isCallable = isCallable$h;
var isNullOrUndefined = isNullOrUndefined$4;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$3;
var toString$3 = toString$8;
var requireObjectCoercible$2 = requireObjectCoercible$8;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$3;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$c;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat$1 = uncurryThis$4([].concat);
var push = uncurryThis$4([].push);
var stringIndexOf$1 = uncurryThis$4(''.indexOf);
var stringSlice = uncurryThis$4(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$4(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$2(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call$2(replacer, searchValue, O, replaceValue)
        : call$2(nativeReplace, toString$3(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$1(this);
      var S = toString$3(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString$3(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$3(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$3(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString$3(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

function parseQuery(query) {
  if (query.startsWith('?')) {
    query = query.substring(1);
  }
  const result = {};
  for (const keyAndValue of query.split('&').filter(x => !!x)) {
    const splitKeyAndValue = keyAndValue.split('=');
    const key = decode(splitKeyAndValue[0]);
    if (!(key in result)) {
      result[key] = [];
    }
    if (splitKeyAndValue[1] !== '') {
      result[key].push(decode(splitKeyAndValue[1]));
    }
  }
  return result;
}
function renderQuery(query, prefixedByQuestionMark = false) {
  let result = prefixedByQuestionMark ? '?' : '';
  let prefix = '';
  for (const key of Object.keys(query)) {
    let values = query[key];
    if (values.length === 0) {
      values = [''];
    }
    for (const value of values) {
      result += prefix + encode(key) + '=' + encode(value);
      prefix = '&';
    }
  }
  return result;
}
function encode(value) {
  return encodeURIComponent(value).replace('%20', '+');
}
function decode(value) {
  return decodeURIComponent(value.replace('+', '%20'));
}
function combineUrls(baseUrl, relativeUrl) {
  return relativeUrl ? baseUrl.replace(/\/+$/, '') + '/' + relativeUrl.replace(/^\/+/, '') : baseUrl;
}

function canLog() {
  return (console === null || console === void 0 ? void 0 : console.log) !== undefined;
}
function logQuery() {
  var _a;
  if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) {
    const parsed = parseQuery(window.location.search);
    return parsed.log;
  }
  return undefined;
}
function log(message, ...optionalParams) {
  const query = logQuery();
  if (!canLog() || query === undefined) {
    return;
  }
  if (query.length === 0 || typeof message === 'string' && query.indexOf(message) !== -1) {
    console.log(message, ...optionalParams);
  }
}

var call$1 = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call$1(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$5;
var anObject = anObject$a;
var $toString = toString$8;
var fails$3 = fails$j;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$3(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$3 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$8;
var toString$2 = toString$8;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$3(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$2(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var global$1 = global$f;
var fails$2 = fails$j;
var uncurryThis$2 = functionUncurryThis;
var toString$1 = toString$8;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = global$1.parseInt;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$2(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails$2(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString$1(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$3 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$3({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

const DateSerializer = {
  serialize: item => {
    const year = item.getFullYear();
    const month = item.getMonth() + 1;
    const dayOfMonth = item.getDate();
    const monthString = month < 10 ? '0' + month : month;
    const dayOfMonthString = dayOfMonth < 10 ? '0' + dayOfMonth : dayOfMonth;
    const dateString = `${year}-${monthString}-${dayOfMonthString}`;
    return dateString;
  },
  deserialize: value => {
    const sanitizedValue = value.replace(/-/g, '/');
    return new Date(sanitizedValue);
  }
};
const BooleanSerializer = {
  serialize: value => {
    return value ? 'true' : 'false';
  },
  deserialize: value => {
    return value.toLocaleLowerCase() === 'true';
  }
};
const IntSerializer = {
  serialize: value => value.toString(),
  deserialize: value => parseInt(value, 10)
};
const DummySerializer = {
  serialize: value => value,
  deserialize: value => value
};
const IdentitySerializer = {
  serialize: value => value,
  deserialize: value => value
};

function sortedIndex(array, element, comparison) {
  let minIndex = 0;
  let maxIndex = array.length - 1;
  let currentIndex = 0;
  let currentElement = array[currentIndex];
  while (minIndex <= maxIndex) {
    currentIndex = Math.floor((minIndex + maxIndex) / 2);
    currentElement = array[currentIndex];
    const compare = comparison(currentElement, element);
    if (compare < 0) {
      minIndex = currentIndex + 1;
    } else if (compare > 0) {
      maxIndex = currentIndex - 1;
    } else {
      return currentIndex;
    }
  }
  return currentElement && comparison(currentElement, element) < 0 ? currentIndex + 1 : currentIndex;
}
function insertSorted(items, item, comparison) {
  items.splice(sortedIndex(items, item, comparison), 0, item);
}
function toggleValue(value, values) {
  const index = values.indexOf(value);
  index < 0 ? values.push(value) : values.splice(index, 1);
}

var DESCRIPTORS = descriptors;
var uncurryThis$1 = functionUncurryThis;
var call = functionCall;
var fails$1 = fails$j;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$1([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

let activeFeatures = null;
function getFeaturesInQuery() {
  const query = parseQuery(window.location.search);
  const result = {};
  if ('btf' in query) {
    for (let featureName of query['btf']) {
      let isActive = true;
      if (featureName.startsWith('!')) {
        featureName = featureName.substr(1);
        isActive = false;
      }
      result[featureName] = isActive;
    }
  }
  return result;
}
function getFeaturesInStore() {
  var _a;
  let storedValue = null;
  try {
    storedValue = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('btf');
  } catch (error) {
    log('Error accessing localStorage', error);
  }
  let result = {};
  if (storedValue !== null) {
    try {
      result = JSON.parse(storedValue);
    } catch (error) {
      log('Error getting features from store', error);
    }
  }
  return result;
}
function storeFeatures(features) {
  try {
    if (!window.localStorage) {
      return;
    }
    window.localStorage.setItem('btf', JSON.stringify(features));
  } catch (error) {
    log('Error storing features', error);
  }
}
function getActiveFeatures() {
  if (activeFeatures === null) {
    const queryFeatures = getFeaturesInQuery();
    const storedFeatures = getFeaturesInStore();
    activeFeatures = Object.assign(Object.assign({}, storedFeatures), queryFeatures);
    storeFeatures(activeFeatures);
  }
  return activeFeatures;
}
function feature(featureName) {
  const features = getActiveFeatures();
  return featureName in features && features[featureName];
}

class Cache {
  constructor(maxNumberOfValues) {
    this.maxNumberOfValues = maxNumberOfValues;
    this.values = {};
    this.allValues = [];
  }
  contains(key) {
    return key in this.values;
  }
  get(key) {
    return this.values[key];
  }
  insert(key, value) {
    if (this.allValues.length >= this.maxNumberOfValues) {
      this.evict(this.allValues[0][0]);
      this.allValues = this.allValues.slice(1);
    }
    this.allValues.push([key, value]);
    this.values[key] = value;
  }
  evict(key) {
    delete this.values[key];
  }
}

let subscription = 0;
function logged(name) {
  return source => {
    const prefix = name + ' ' + subscription++;
    log(prefix, 'subscribed');
    return new Observable(subscriber => {
      let completed = false;
      const subscription = source.subscribe({
        next: item => {
          log(prefix, 'new item', item);
          subscriber.next(item);
        },
        error: error => {
          log(prefix, 'error', error);
          completed = true;
          subscriber.error(error);
        },
        complete: () => {
          log(prefix, 'completed');
          completed = true;
          subscriber.complete();
        }
      });
      return () => {
        if (!completed) {
          log(prefix, 'cancelled');
        }
        log(prefix, 'disposed');
        subscription.unsubscribe();
      };
    });
  };
}
function toDictionary(keySelector) {
  return source => {
    return source.pipe(toArray(), map(x => {
      return asq(x).pipe(toDictionary$1(keySelector)).single();
    }));
  };
}

var $$1 = _export;
var $includes = arrayIncludes.includes;
var fails = fails$j;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$1({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$8;
var toString = toString$8;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const defaultSupportPage = 'https://sembo.freshdesk.com/en/support/home';
class DomainMapping {
  getDomainSpec(domain) {
    switch (domain) {
      case Domains.SWEDEN:
        return {
          Number: 1,
          Domain: 'sembo.se',
          IsSubdomain: false,
          Locale: 'sv',
          FullLocale: 'sv-SE',
          Currency: 'SEK',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Bygg din resa - Hotell, flyg, färjor, aktiviteter, enstaka eller flera stopp!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/sv-SE/support/home'
        };
      case Domains.NORWAY:
        return {
          Number: 4,
          Domain: 'sembo.no',
          IsSubdomain: false,
          Locale: 'no',
          FullLocale: 'nb-NO',
          Currency: 'NOK',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Bygg turen din - Hoteller, fly, ferger, aktiviteter, enkelt eller flere stopp!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/nb-NO/support/home'
        };
      case Domains.FINLAND:
        return {
          Number: 6,
          Domain: 'sembo.fi',
          IsSubdomain: false,
          Locale: 'fi',
          FullLocale: 'fi-FI',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Rakenna matkasi - Hotellit, lennot, lautat, aktiviteetit, yksi tai useampi pysähdys!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/fi/support/home'
        };
      case Domains.GERMANY:
        return {
          Number: 7,
          Domain: 'sembo.de',
          IsSubdomain: false,
          Locale: 'de',
          FullLocale: 'de-DE',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Stelle deine Reise zusammen - Hotels, Flüge, Fähren, Aktivitäten, einzelne oder mehrere Stopps!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/de/support/home'
        };
      case Domains.POLAND:
        return {
          Number: 8,
          Domain: 'sembo.pl',
          IsSubdomain: false,
          Locale: 'pl',
          FullLocale: 'pl-PL',
          Currency: 'PLN',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Zbuduj swoją podróż - Hotele, loty, promy, aktywności, pojedyncze lub wielokrotne przystanki!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.NETHERLAND:
        return {
          Number: 9,
          Domain: 'sembo.nl',
          IsSubdomain: false,
          Locale: 'nl',
          FullLocale: 'nl-NL',
          Currency: 'EUR',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Stel je reis samen - Hotels, vluchten, veerboten, activiteiten, enkele of meerdere stops!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/nl/support/home'
        };
      case Domains.UNITEDKINGDOM:
        return {
          Number: 10,
          Domain: 'sembo.co.uk',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-GB',
          Currency: 'GBP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Build your trip - Hotels, flights, ferries, activities, single or multiple stops!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.IRELAND:
        return {
          Number: 11,
          Domain: 'sembo.ie',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-IE',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.AUSTRIA:
        return {
          Number: 12,
          Domain: 'sembo.at',
          IsSubdomain: false,
          Locale: 'de',
          FullLocale: 'de-AT',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/de/support/home'
        };
      case Domains.HUNGARY:
        return {
          Number: 13,
          Domain: 'sembo.hu',
          IsSubdomain: false,
          Locale: 'hu',
          FullLocale: 'hu-HU',
          Currency: 'HUF',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.AUSTRALIA:
        return {
          Number: 14,
          Domain: 'sembo.com.au',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-AU',
          Currency: 'AUD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.NEWZEELAND:
        return {
          Number: 15,
          Domain: 'sembo.nz',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-NZ',
          Currency: 'NZL',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.USA:
        return {
          Number: 16,
          Domain: 'sembo.com',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-US',
          Currency: 'USD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CANADA:
        return {
          Number: 17,
          Domain: 'sembo.ca',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-CA',
          Currency: 'CAD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SOUTHAFRICA:
        return {
          Number: 18,
          Domain: 'sembo.co.za',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-ZA',
          Currency: 'ZAR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SINGAPORE:
        return {
          Number: 19,
          Domain: 'sembo.sg',
          IsSubdomain: false,
          Locale: 'en',
          FullLocale: 'en-SG',
          Currency: 'SGD',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SPAIN:
        return {
          Number: 20,
          Domain: 'sembo.es',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-ES',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Construye tu viaje - Hoteles, vuelos, ferries, actividades, paradas individuales o múltiples!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/es/support/home'
        };
      case Domains.PORTUGAL:
        return {
          Number: 21,
          Domain: 'sembo.pt',
          IsSubdomain: false,
          Locale: 'pt',
          FullLocale: 'pt-PT',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.UNITEDARABEMIRATES:
        return {
          Number: 23,
          Domain: 'ae.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-AE',
          Currency: 'AED',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BULGARIA:
        return {
          Number: 24,
          Domain: 'sembo.bg',
          IsSubdomain: false,
          Locale: 'bg',
          FullLocale: 'bg-BG',
          Currency: 'BGN',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CZECHREPUBLIC:
        return {
          Number: 25,
          Domain: 'cz.sembo.com',
          IsSubdomain: true,
          Locale: 'cs',
          FullLocale: 'cs-CZ',
          Currency: 'CZK',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.INDIA:
        return {
          Number: 26,
          Domain: 'sembo.in',
          IsSubdomain: false,
          Locale: 'hi',
          FullLocale: 'hi-IN',
          Currency: 'INR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.PHILIPPINES:
        return {
          Number: 27,
          Domain: 'ph.sembo.com',
          IsSubdomain: true,
          Locale: 'en',
          FullLocale: 'en-PH',
          Currency: 'PHP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.NIGERIA:
        return {
          Number: 28,
          Domain: 'ng.sembo.com',
          IsSubdomain: true,
          Locale: 'en',
          FullLocale: 'en-NG',
          Currency: 'NGN',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.MEXICO:
        return {
          Number: 29,
          Domain: 'sembo.com.mx',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-MX',
          Currency: 'MXN',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ARGENTINA:
        return {
          Number: 30,
          Domain: 'sembo.com.ar',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-AR',
          Currency: 'ARS',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.COLOMBIA:
        return {
          Number: 31,
          Domain: 'sembo.com.co',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-CO',
          Currency: 'COP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CHILE:
        return {
          Number: 32,
          Domain: 'sembo.cl',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-CL',
          Currency: 'CLP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.PERU:
        return {
          Number: 33,
          Domain: 'sembo.pe',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-PE',
          Currency: 'PEN',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ECUADOR:
        return {
          Number: 34,
          Domain: 'sembo.com.ec',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-EC',
          Currency: 'USD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.URUGUAY:
        return {
          Number: 35,
          Domain: 'sembo.com.uy',
          IsSubdomain: false,
          Locale: 'es',
          FullLocale: 'es-UY',
          Currency: 'UYU',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ISRAEL:
        return {
          Number: 36,
          Domain: 'sembo.co.il',
          IsSubdomain: false,
          Locale: 'he',
          FullLocale: 'he-IL',
          Currency: 'ILS',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CROATIA:
        return {
          Number: 37,
          Domain: 'hr.sembo.com',
          IsSubdomain: true,
          Locale: 'hr',
          FullLocale: 'hr-HR',
          Currency: 'HRK',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.INDONESIA:
        return {
          Number: 38,
          Domain: 'id.sembo.com',
          IsSubdomain: true,
          Locale: 'id',
          FullLocale: 'id-ID',
          Currency: 'IDR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SOUTHKOREA:
        return {
          Number: 39,
          Domain: 'kr.sembo.com',
          IsSubdomain: true,
          Locale: 'ko',
          FullLocale: 'ko-KR',
          Currency: 'KRW',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.MALAYSIA:
        return {
          Number: 40,
          Domain: 'my.sembo.com',
          IsSubdomain: true,
          Locale: 'ms',
          FullLocale: 'ms-MY',
          Currency: 'MYR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BELGIUM:
        return {
          Number: 41,
          Domain: 'sembo.be',
          IsSubdomain: false,
          Locale: 'nl',
          FullLocale: 'nl-BE',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BRAZIL:
        return {
          Number: 42,
          Domain: 'sembo.com.br',
          IsSubdomain: false,
          Locale: 'pt',
          FullLocale: 'pt-BR',
          Currency: 'BRL',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ROMANIA:
        return {
          Number: 43,
          Domain: 'sembo.ro',
          IsSubdomain: false,
          Locale: 'ro',
          FullLocale: 'ro-RO',
          Currency: 'RON',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SERBIA:
        return {
          Number: 44,
          Domain: 'rs.sembo.com',
          IsSubdomain: true,
          Locale: 'sr',
          FullLocale: 'sr-RS',
          Currency: 'RSD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.RUSSIA:
        return {
          Number: 45,
          Domain: 'sembo.ru',
          IsSubdomain: false,
          Locale: 'ru',
          FullLocale: 'ru-RU',
          Currency: 'RUB',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SLOVAKIA:
        return {
          Number: 47,
          Domain: 'sk.sembo.com',
          IsSubdomain: true,
          Locale: 'sk',
          FullLocale: 'sk-SK',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.THAILAND:
        return {
          Number: 48,
          Domain: 'th.sembo.com',
          IsSubdomain: true,
          Locale: 'th',
          FullLocale: 'th-TH',
          Currency: 'THB',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.VIETNAM:
        return {
          Number: 49,
          Domain: 'vn.sembo.com',
          IsSubdomain: true,
          Locale: 'vi',
          FullLocale: 'vi-VN',
          Currency: 'VND',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.TAIWAN:
        return {
          Number: 50,
          Domain: 'tw.sembo.com',
          IsSubdomain: true,
          Locale: 'zh',
          FullLocale: 'zh-TW',
          Currency: 'TWD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.HONGKONG:
        return {
          Number: 51,
          Domain: 'hk.sembo.com',
          IsSubdomain: true,
          Locale: 'zh',
          FullLocale: 'zh-HK',
          Currency: 'HKD',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SWITZERLAND:
        return {
          Number: 52,
          Domain: 'ch.sembo.com',
          IsSubdomain: true,
          Locale: 'de',
          FullLocale: 'de-CH',
          Currency: 'CHF',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/de/support/home'
        };
      case Domains.GREECE:
        return {
          Number: 53,
          Domain: 'sembo.gr',
          IsSubdomain: false,
          Locale: 'el',
          FullLocale: 'el-GR',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BAHRAIN:
        return {
          Number: 54,
          Domain: 'bh.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-BH',
          Currency: 'BHD',
          Digits: 3,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BELARUS:
        return {
          Number: 55,
          Domain: 'by.sembo.com',
          IsSubdomain: true,
          Locale: 'be',
          FullLocale: 'be-BY',
          Currency: 'BYN',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.BOLIVIA:
        return {
          Number: 56,
          Domain: 'bo.sembo.com',
          IsSubdomain: true,
          Locale: 'es',
          FullLocale: 'es-BO',
          Currency: 'BOB',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CHINA:
        return {
          Number: 57,
          Domain: 'cn.sembo.com',
          IsSubdomain: true,
          Locale: 'zh',
          FullLocale: 'zh-CN',
          Currency: 'CNY',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CUBA:
        return {
          Number: 58,
          Domain: 'cu.sembo.com',
          IsSubdomain: true,
          Locale: 'es',
          FullLocale: 'es-CU',
          Currency: 'CUP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.CYPRUS:
        return {
          Number: 59,
          Domain: 'cy.sembo.com',
          IsSubdomain: true,
          Locale: 'el',
          FullLocale: 'el-CY',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.DOMINICANREPUBLIC:
        return {
          Number: 60,
          Domain: 'do.sembo.com',
          IsSubdomain: true,
          Locale: 'es',
          FullLocale: 'es-DO',
          Currency: 'DOP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.EGYPT:
        return {
          Number: 61,
          Domain: 'eg.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-EG',
          Currency: 'EGP',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ESTONIA:
        return {
          Number: 62,
          Domain: 'sembo.ee',
          IsSubdomain: false,
          Locale: 'et',
          FullLocale: 'et-EE',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.FRANCE:
        return {
          Number: 63,
          Domain: 'sembo.fr',
          IsSubdomain: false,
          Locale: 'fr',
          FullLocale: 'fr-FR',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo: Construisez votre voyage - Hôtels, vols, ferries, activités, arrêts simples ou multiples!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ICELAND:
        return {
          Number: 64,
          Domain: 'sembo.is',
          IsSubdomain: false,
          Locale: 'is',
          FullLocale: 'is-IS',
          Currency: 'ISK',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.IRAN:
        return {
          Number: 65,
          Domain: 'ir.sembo.com',
          IsSubdomain: true,
          Locale: 'fa',
          FullLocale: 'fa-IR',
          Currency: 'IRR',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.ITALY:
        return {
          Number: 66,
          Domain: 'it.sembo.com',
          IsSubdomain: true,
          Locale: 'it',
          FullLocale: 'it-IT',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.JAPAN:
        return {
          Number: 67,
          Domain: 'jp.sembo.com',
          IsSubdomain: true,
          Locale: 'ja',
          FullLocale: 'ja-JP',
          Currency: 'JPY',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.JORDAN:
        return {
          Number: 68,
          Domain: 'jo.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-JO',
          Currency: 'JOD',
          Digits: 3,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.KAZAKHSTAN:
        return {
          Number: 69,
          Domain: 'kz.sembo.com',
          IsSubdomain: true,
          Locale: 'kk',
          FullLocale: 'kk-KZ',
          Currency: 'KZT',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.KUWAIT:
        return {
          Number: 70,
          Domain: 'kw.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-KW',
          Currency: 'KWD',
          Digits: 3,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.LUXEMBOURG:
        return {
          Number: 71,
          Domain: 'lu.sembo.com',
          IsSubdomain: true,
          Locale: 'fr',
          FullLocale: 'fr-LU',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.MALTA:
        return {
          Number: 72,
          Domain: 'mt.sembo.com',
          IsSubdomain: true,
          Locale: 'mt',
          FullLocale: 'mt-MT',
          Currency: 'EUR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.OMAN:
        return {
          Number: 73,
          Domain: 'om.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-OM',
          Currency: 'OMR',
          Digits: 3,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.PARAGUAY:
        return {
          Number: 74,
          Domain: 'py.sembo.com',
          IsSubdomain: true,
          Locale: 'es',
          FullLocale: 'es-PY',
          Currency: 'PYG',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.QATAR:
        return {
          Number: 75,
          Domain: 'qa.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-QA',
          Currency: 'QAR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.SAUDIARABIA:
        return {
          Number: 76,
          Domain: 'sa.sembo.com',
          IsSubdomain: true,
          Locale: 'ar',
          FullLocale: 'ar-SA',
          Currency: 'SAR',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.TURKEY:
        return {
          Number: 77,
          Domain: 'tr.sembo.com',
          IsSubdomain: true,
          Locale: 'tr',
          FullLocale: 'tr-TR',
          Currency: 'TRY',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.UKRAINE:
        return {
          Number: 78,
          Domain: 'ua.sembo.com',
          IsSubdomain: true,
          Locale: 'uk',
          FullLocale: 'uk-UA',
          Currency: 'UAH',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.VENEZUELA:
        return {
          Number: 79,
          Domain: 've.sembo.com',
          IsSubdomain: true,
          Locale: 'es',
          FullLocale: 'es-VE',
          Currency: 'VES',
          Digits: 2,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: defaultSupportPage
        };
      case Domains.DENMARK:
        return {
          Number: 5,
          Domain: 'sembo.dk',
          IsSubdomain: false,
          Locale: 'dk',
          FullLocale: 'da-DK',
          Currency: 'DKK',
          Digits: 0,
          Logo: 'dtf_logo_v2.svg',
          Title: 'Sembo: Skab din rejse - Hoteller, flyrejser, færger, aktiviteter, enkelt eller flere stop!',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/da/support/home'
        };
      case Domains.DTFDENMARK:
        return {
          Number: 405,
          Domain: 'dtf-travel.dk',
          IsSubdomain: false,
          Locale: 'dk',
          FullLocale: 'da-DK',
          Currency: 'DKK',
          Digits: 0,
          Logo: 'dtf_logo_v2.svg',
          Title: 'DTF Travel',
          GeneralTermsRelativePath: '/pages/terms-dtf.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/da/support/home'
        };
      case Domains.STENASWEDEN:
        return {
          Number: 101,
          Domain: 'sembo.stenaline.se',
          IsSubdomain: true,
          Locale: 'sv',
          FullLocale: 'sv-SE',
          Currency: 'SEK',
          Digits: 0,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENANORWAY:
        return {
          Number: 104,
          Domain: 'sembo.stenaline.no',
          IsSubdomain: true,
          Locale: 'no',
          FullLocale: 'nb-NO',
          Currency: 'NOK',
          Digits: 0,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENADENMARK:
        return {
          Number: 105,
          Domain: 'sembo.stenaline.dk',
          IsSubdomain: true,
          Locale: 'dk',
          FullLocale: 'da-DK',
          Currency: 'DKK',
          Digits: 0,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENAFINLAND:
        return {
          Number: 106,
          Domain: 'sembo.stenaline.fi',
          IsSubdomain: true,
          Locale: 'fi',
          FullLocale: 'fi-FI',
          Currency: 'EUR',
          Digits: 2,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENAGERMANY:
        return {
          Number: 107,
          Domain: 'sembo.stenaline.de',
          IsSubdomain: true,
          Locale: 'de',
          FullLocale: 'de-DE',
          Currency: 'EUR',
          Digits: 2,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENAPOLAND:
        return {
          Number: 108,
          Domain: 'sembo.stenaline.pl',
          IsSubdomain: true,
          Locale: 'pl',
          FullLocale: 'pl-PL',
          Currency: 'PLN',
          Digits: 0,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENANETHERLAND:
        return {
          Number: 109,
          Domain: 'sembo.stenaline.nl',
          IsSubdomain: true,
          Locale: 'nl',
          FullLocale: 'nl-NL',
          Currency: 'EUR',
          Digits: 0,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENAUNITEDKINGDOM:
        return {
          Number: 110,
          Domain: 'sembo.stenaline.co.uk',
          IsSubdomain: true,
          Locale: 'en',
          FullLocale: 'en-GB',
          Currency: 'GBP',
          Digits: 2,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      case Domains.STENAIRELAND:
        return {
          Number: 111,
          Domain: 'sembo.stenaline.ie',
          IsSubdomain: true,
          Locale: 'en',
          FullLocale: 'en-IE',
          Currency: 'EUR',
          Digits: 2,
          Logo: '',
          Title: 'StenaLine',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: true,
          SupportPage: defaultSupportPage
        };
      default:
        return {
          Number: 1,
          Domain: 'sembo.se',
          IsSubdomain: false,
          Locale: 'sv',
          FullLocale: 'sv-SE',
          Currency: 'SEK',
          Digits: 0,
          Logo: 'sembo_logo_blank.svg',
          Title: 'Sembo',
          GeneralTermsRelativePath: '/pages/terms.aspx',
          IsStenaCompany: false,
          SupportPage: 'https://sembo.freshdesk.com/sv-SE/support/home'
        };
    }
  }
  get isWhiteLabel() {
    return this.hostContains('whitelabel');
  }
  get isStenaLine() {
    return this.hostContains('stenaline');
  }
  get isLocalhost() {
    return this.hostContains('localhost') || this.hostContains('127.0.0.1');
  }
  get isStaging() {
    return this.hostContains('sembo-stage');
  }
  get isProduction() {
    return !this.isLocalhost && !this.isStaging;
  }
  get isDanishMarket() {
    return getDomain.getCurrentDomainSpec().Locale === 'dk';
  }
  get isGermanMarket() {
    return getDomain.getCurrentDomainSpec().Locale === 'de';
  }
  getCurrentDomainSpec() {
    var _a;
    const currentHost = window.location.host.replace('www.', '').replace('whitelabel.', '');
    let currentDomain = this.getDomainSpec(Domains.SWEDEN);
    if (this.isProduction) {
      Object.keys(Domains).forEach(key => {
        const domain = this.getDomainSpec(Domains[key]);
        if (currentHost === domain.Domain) {
          currentDomain = domain;
          return;
        }
      });
    } else {
      const defaultLocale = 'sv';
      const locale = (_a = this.parseQueryString(window.location.href).locale) !== null && _a !== void 0 ? _a : defaultLocale;
      Object.keys(Domains).forEach(key => {
        const domain = this.getDomainSpec(Domains[key]);
        if (locale.includes(domain.Locale) && !domain.IsStenaCompany) {
          currentDomain = domain;
        }
      });
    }
    return currentDomain;
  }
  getLanguageLocale() {
    if (this.isProduction) {
      return this.getCurrentDomainSpec().Locale;
    }
    const defaultUserLocale = 'en';
    const queryStringLocale = this.parseQueryString(window.location.href).locale;
    return Array.isArray(queryStringLocale) ? queryStringLocale[0] : queryStringLocale !== null && queryStringLocale !== void 0 ? queryStringLocale : defaultUserLocale;
  }
  parseQueryString(query) {
    const queryString = {};
    const queryParams = query.split('?')[1];
    if (!queryParams) {
      return queryString;
    }
    queryParams.split('&').forEach(param => {
      const [key, value] = param.split('=').map(decodeURIComponent);
      if (!queryString[key]) {
        queryString[key] = value;
      } else if (typeof queryString[key] === 'string') {
        queryString[key] = [queryString[key], value];
      } else {
        queryString[key].push(value);
      }
    });
    return queryString;
  }
  hostContains(value) {
    return window.location.host.includes(value);
  }
}
var Domains;
(function (Domains) {
  Domains[Domains["ARGENTINA"] = 0] = "ARGENTINA";
  Domains[Domains["AUSTRALIA"] = 1] = "AUSTRALIA";
  Domains[Domains["AUSTRIA"] = 2] = "AUSTRIA";
  Domains[Domains["BAHRAIN"] = 3] = "BAHRAIN";
  Domains[Domains["BELARUS"] = 4] = "BELARUS";
  Domains[Domains["BELGIUM"] = 5] = "BELGIUM";
  Domains[Domains["BOLIVIA"] = 6] = "BOLIVIA";
  Domains[Domains["BRAZIL"] = 7] = "BRAZIL";
  Domains[Domains["BULGARIA"] = 8] = "BULGARIA";
  Domains[Domains["CANADA"] = 9] = "CANADA";
  Domains[Domains["CHILE"] = 10] = "CHILE";
  Domains[Domains["CHINA"] = 11] = "CHINA";
  Domains[Domains["COLOMBIA"] = 12] = "COLOMBIA";
  Domains[Domains["CROATIA"] = 13] = "CROATIA";
  Domains[Domains["CUBA"] = 14] = "CUBA";
  Domains[Domains["CYPRUS"] = 15] = "CYPRUS";
  Domains[Domains["CZECHREPUBLIC"] = 16] = "CZECHREPUBLIC";
  Domains[Domains["DENMARK"] = 17] = "DENMARK";
  Domains[Domains["DOMINICANREPUBLIC"] = 18] = "DOMINICANREPUBLIC";
  Domains[Domains["DTFDENMARK"] = 19] = "DTFDENMARK";
  Domains[Domains["ECUADOR"] = 20] = "ECUADOR";
  Domains[Domains["EGYPT"] = 21] = "EGYPT";
  Domains[Domains["ESTONIA"] = 22] = "ESTONIA";
  Domains[Domains["FINLAND"] = 23] = "FINLAND";
  Domains[Domains["FRANCE"] = 24] = "FRANCE";
  Domains[Domains["GERMANY"] = 25] = "GERMANY";
  Domains[Domains["GREECE"] = 26] = "GREECE";
  Domains[Domains["HONGKONG"] = 27] = "HONGKONG";
  Domains[Domains["HUNGARY"] = 28] = "HUNGARY";
  Domains[Domains["ICELAND"] = 29] = "ICELAND";
  Domains[Domains["INDIA"] = 30] = "INDIA";
  Domains[Domains["INDONESIA"] = 31] = "INDONESIA";
  Domains[Domains["IRAN"] = 32] = "IRAN";
  Domains[Domains["IRELAND"] = 33] = "IRELAND";
  Domains[Domains["ISRAEL"] = 34] = "ISRAEL";
  Domains[Domains["ITALY"] = 35] = "ITALY";
  Domains[Domains["JAPAN"] = 36] = "JAPAN";
  Domains[Domains["JORDAN"] = 37] = "JORDAN";
  Domains[Domains["KAZAKHSTAN"] = 38] = "KAZAKHSTAN";
  Domains[Domains["KUWAIT"] = 39] = "KUWAIT";
  Domains[Domains["LUXEMBOURG"] = 40] = "LUXEMBOURG";
  Domains[Domains["MALAYSIA"] = 41] = "MALAYSIA";
  Domains[Domains["MALTA"] = 42] = "MALTA";
  Domains[Domains["MEXICO"] = 43] = "MEXICO";
  Domains[Domains["NETHERLAND"] = 44] = "NETHERLAND";
  Domains[Domains["NEWZEELAND"] = 45] = "NEWZEELAND";
  Domains[Domains["NIGERIA"] = 46] = "NIGERIA";
  Domains[Domains["NORWAY"] = 47] = "NORWAY";
  Domains[Domains["OMAN"] = 48] = "OMAN";
  Domains[Domains["PARAGUAY"] = 49] = "PARAGUAY";
  Domains[Domains["PERU"] = 50] = "PERU";
  Domains[Domains["PHILIPPINES"] = 51] = "PHILIPPINES";
  Domains[Domains["POLAND"] = 52] = "POLAND";
  Domains[Domains["PORTUGAL"] = 53] = "PORTUGAL";
  Domains[Domains["QATAR"] = 54] = "QATAR";
  Domains[Domains["ROMANIA"] = 55] = "ROMANIA";
  Domains[Domains["RUSSIA"] = 56] = "RUSSIA";
  Domains[Domains["SAUDIARABIA"] = 57] = "SAUDIARABIA";
  Domains[Domains["SERBIA"] = 58] = "SERBIA";
  Domains[Domains["SINGAPORE"] = 59] = "SINGAPORE";
  Domains[Domains["SLOVAKIA"] = 60] = "SLOVAKIA";
  Domains[Domains["SOUTHAFRICA"] = 61] = "SOUTHAFRICA";
  Domains[Domains["SOUTHKOREA"] = 62] = "SOUTHKOREA";
  Domains[Domains["SPAIN"] = 63] = "SPAIN";
  Domains[Domains["SWEDEN"] = 64] = "SWEDEN";
  Domains[Domains["STENASWEDEN"] = 65] = "STENASWEDEN";
  Domains[Domains["STENANORWAY"] = 66] = "STENANORWAY";
  Domains[Domains["STENADENMARK"] = 67] = "STENADENMARK";
  Domains[Domains["STENAFINLAND"] = 68] = "STENAFINLAND";
  Domains[Domains["STENAGERMANY"] = 69] = "STENAGERMANY";
  Domains[Domains["STENAPOLAND"] = 70] = "STENAPOLAND";
  Domains[Domains["STENANETHERLAND"] = 71] = "STENANETHERLAND";
  Domains[Domains["STENAUNITEDKINGDOM"] = 72] = "STENAUNITEDKINGDOM";
  Domains[Domains["STENAIRELAND"] = 73] = "STENAIRELAND";
  Domains[Domains["SWITZERLAND"] = 74] = "SWITZERLAND";
  Domains[Domains["TAIWAN"] = 75] = "TAIWAN";
  Domains[Domains["THAILAND"] = 76] = "THAILAND";
  Domains[Domains["TURKEY"] = 77] = "TURKEY";
  Domains[Domains["UKRAINE"] = 78] = "UKRAINE";
  Domains[Domains["UNITEDARABEMIRATES"] = 79] = "UNITEDARABEMIRATES";
  Domains[Domains["UNITEDKINGDOM"] = 80] = "UNITEDKINGDOM";
  Domains[Domains["URUGUAY"] = 81] = "URUGUAY";
  Domains[Domains["USA"] = 82] = "USA";
  Domains[Domains["VENEZUELA"] = 83] = "VENEZUELA";
  Domains[Domains["VIETNAM"] = 84] = "VIETNAM";
})(Domains || (Domains = {}));
const getDomain = new DomainMapping();

export { BooleanSerializer, Cache, DateSerializer, Domains, DummySerializer, IdentitySerializer, IntSerializer, combineUrls, feature, getDomain, insertSorted, log, logged, parseQuery, renderQuery, sortedIndex, toDictionary, toggleValue };
